import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const usersServiceRequestsStyle = () => ({
	datePicker: {
		width: 'calc(50% - 4px)',
		display: 'inline-block',
		'&:first-child': {
			marginRight: 4,
		},
		'&:nth-child(2)': {
			marginLeft: 4,
		},
		'& .MuiFormControl-root': {
			marginBottom: 8,
		},
	},
	numberCallIcon: {
		color: blackColors[4],
		fontSize: '14px',
		marginRight: '6px',
	},
});

export default usersServiceRequestsStyle;
